<span class="profile-contacts">
  @for (item of contactsData | keyvalue; track item; let i = $index) {
    <span class="contact__title">
      {{ (item.value.contactTitle | translate) + ':' }}
    </span>
    @for (contact of item.value.values; track contact; let j = $index) {
      @if (contact.hide) {
        <span
          class="contact__name hidden-contact"
          [class.last]="j === item.value.values.length - 1">
          {{ '...' + contact.value }}
        </span>
      } @else {
        <span
          appCandidateContactHandler
          class="contact__name open-contact"
          [class.last]="j === item.value.values.length - 1">
          {{ contact.value }}
        </span>
      }
    }
  }
</span>
